module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/video_frame-f49b6273299043ff28297ad6ffc3a4f3.svg";